import * as React from 'react';
import { useState } from 'react';
import { SnapshotsModal } from './SnapshotsModal';
import type { ReservationState } from '@digitalopsdev/serviceops-reservations-components/dist/EditReservation/types';
import { useClientSettings } from '@digitalopsdev/serviceops-reservations-components/dist/EditReservation/ClientSettingsContext';

interface Props {
    reservationState: ReservationState;
}

export const SnapshotsToolButton: React.FC<Props> = ({ reservationState }) => {
    const [showModal, setShowModal] = useState(false);
    const { isSuperAdmin } = useClientSettings();

    if (!reservationState.ReservationId) return null;
    if (!isSuperAdmin) return null;

    return (
        <>
            <button
                className="btn btn-outline-contrast"
                onClick={() => setShowModal(true)}
            >
                <i className="fa-solid fa-camera me-1"></i>
                Snapshots
            </button>
            {showModal && (
                <SnapshotsModal
                    reservationState={reservationState}
                    onClose={() => setShowModal(false)}
                />
            )}
        </>
    );
};
